module.exports = __webpack_public_path__ + "img/aqt-logo3.ae0c79f4.png";